import { MdOutlineEmail, MdOutlineLocalHospital } from 'react-icons/md';
import { PiPhoneOutgoing } from 'react-icons/pi';
import { InfoRow } from '@features/modals/UserInfoModal/components';
import { ModalContentSection } from '@features/modals/UserInfoModal/components/ModalContentSection';
import { formatPhoneNumber } from '@/utils/helpers';

type UserModalContentProps = {
  hospitalLabel?: string;
  hospitalName?: string;
  primaryPhone?: string | null;
  secondaryPhone?: string | null;
  email: string | null;
};

export const UserModalContent = ({
  hospitalLabel,
  hospitalName,
  primaryPhone = '',
  secondaryPhone = '',
  email,
}: UserModalContentProps) => {
  return (
    <ModalContentSection header="Contact Information">
      <div className="grid grid-cols-2 gap-8">
        {hospitalLabel && (
          <InfoRow
            withTruncate={false}
            name={hospitalLabel}
            value={hospitalName}
            icon={<MdOutlineLocalHospital size={28} />}
          />
        )}
        <InfoRow
          name="Primary Phone Number"
          value={primaryPhone ? formatPhoneNumber(primaryPhone) : '-'}
          icon={<PiPhoneOutgoing size={28} />}
        />
        <InfoRow name="Email" value={email} icon={<MdOutlineEmail size={28} />} />
        <InfoRow
          name="Secondary Phone Number"
          value={secondaryPhone ? formatPhoneNumber(secondaryPhone) : '-'}
          icon={<PiPhoneOutgoing size={28} />}
        />
      </div>
    </ModalContentSection>
  );
};
